module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-500-Inactive-Rumble-d90a7c36a14d7c8ea6ba4065f57e922c.png";